import { render, staticRenderFns } from "./new-live-games.vue?vue&type=template&id=b6b29b4a"
import script from "./new-live-games.vue?vue&type=script&lang=js"
export * from "./new-live-games.vue?vue&type=script&lang=js"
import style0 from "./new-live-games.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/new-live-games.vue
// module id = FC9T
// module chunks = 0